import ProfileUpdate from "../components/mainContent/ProfileUpdate";
import { BasePageLayout } from "../components/layouts/BasePageLayout";

export function ProfilePage() {
    return (
        <BasePageLayout title="Profile" showButton={false}>
            <ProfileUpdate />
        </BasePageLayout>
    );
}